import { Component, OnInit, TemplateRef, NgModule } from '@angular/core';
import { Cupom } from '../../model/cupom';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { RelatorioService } from '../../service/relatorio/relatorio.service';
import { DataService } from '../../service/data/data.service';
import { HttpClientModule } from '@angular/common/http';
import { saveAs } from "file-saver";
import { UserDetails } from '../../model/userdetails';

@Component({
  selector: 'app-relatorio',
  templateUrl: './relatorio.component.html',
  styleUrls: ['./relatorio.component.css'],
  providers: [RelatorioService]
})

export class RelatorioComponent implements OnInit {
  p: number = 1;
  cupom: Cupom = new Cupom();
  public cupons: Cupom[] = [];
  modalRef: BsModalRef;
  public inicio: string;
  public fim: string;
  public tipoData: string;
  public tipoArquivo: string;
  public arquivo: string;
  public user: UserDetails;

  constructor(private modalService: BsModalService,
    private dataService: DataService,
    private relatorioService: RelatorioService) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('idUser'));
  }
  
  onGerar() {
    this.user = JSON.parse(localStorage.getItem('idUser'));
    var me = this;
    me.cupons = [];
    this.dataService.currentUserDetails.subscribe(details => {
      me.relatorioService.onConsulta(me.inicio.replace('/', '-').replace('/', '-'), me.fim.replace('/', '-').replace('/', '-'), parseInt(me.tipoData), details.is_Ressarcimento)
        .subscribe((res: Array<any>) => {

          if (res.length > 0) {
            this.cupons = res;
          }
          else {
            this.openModalRetornoConsulta();
          }

        }, error => {
        });
    }).unsubscribe();
  }

  onBaixar() {
    var me = this;
    this.dataService.currentUserDetails.subscribe(details => {
      me.relatorioService.onBaixar(me.inicio.replace('/', '-').replace('/', '-'), me.fim.replace('/', '-').replace('/', '-'), parseInt(me.tipoData), parseInt(me.tipoArquivo), details.is_Ressarcimento);
    }).unsubscribe();
    
  }

  disableGerar() {
    var me = this;
    return (me.inicio == undefined || me.fim == undefined || me.tipoData == undefined);
  }

  disableBaixar() {
    var me = this;
    return (me.inicio == undefined || me.fim == undefined || me.tipoData == undefined || me.tipoArquivo == undefined);
  }

  openModalRetornoConsulta() {
    const initialState = {
      title: 'Informação não encontrada',
      message: 'Nenhum resultado encontrado para sua pesquisa',
      closeBtnName: 'Fechar'
    };

    this.modalRef = this.modalService.show(ModalContentGerarRelatorioComponent, { initialState });
    this.modalRef.content.closeBtnName = 'Close';
  }
}

@Component({
  selector: 'modal-content',
  template: `
    <div class="modal-header">
      <h4 class="modal-title pull-left">{{title}}</h4>
    </div>
    <div class="modal-body">
       <p>{{message}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-default" (click)="bsModalRef.hide()">Fechar</button>
    </div>
  `
})

export class ModalContentGerarRelatorioComponent {
  title: string;
  message: any;
  closeBtnName: string;

  constructor(public bsModalRef: BsModalRef) { }

}
